import React from 'react';
import './Input.scss';

type InputProps = {
    placeholder?: string;
    name: string;
    icon?: JSX.Element;
    className?: string;
    type?: string;
    value?: string;
    pattern?: string;
    required?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    onInput?: (e: React.FormEvent<HTMLInputElement>) => void;
};

export default function Input({ placeholder, name, icon, className, type, value, pattern, required, onChange, onBlur, onInput }: InputProps) {
    return (
        <div className={'input ' + className}>
            <input name={name} id={name} placeholder={placeholder ?? ''} type={type} value={value} pattern={pattern} required={required} onChange={onChange} onBlur={onBlur} onInput={onInput} />
            {icon}
        </div>
    );
}
